import { PRODUCT_TYPE_SCHEMA, PRODUCT_TYPES } from '@schuettflix/interfaces';
import { z } from 'zod';

export const HAZARDOUS_WASTE_PRODUCT_TYPES_SCHEMA = PRODUCT_TYPE_SCHEMA.extract([
    'HAZARDOUS_WASTE_DISPOSAL',
    'HAZARDOUS_WASTE_RECYCLING',
    'CUSTOM_HAZARDOUS_WASTE_DISPOSAL',
    'CUSTOM_HAZARDOUS_WASTE_RECYCLING',
]);
export const NON_HAZARDOUS_WASTE_PRODUCT_TYPES_SCHEMA = PRODUCT_TYPE_SCHEMA.extract([
    'NON_HAZARDOUS_WASTE_DISPOSAL',
    'NON_HAZARDOUS_WASTE_RECYCLING',
    'CUSTOM_NON_HAZARDOUS_WASTE_DISPOSAL',
    'CUSTOM_NON_HAZARDOUS_WASTE_RECYCLING',
]);

export function isWasteProduct(productType: PRODUCT_TYPES) {
    return z
        .enum([...HAZARDOUS_WASTE_PRODUCT_TYPES_SCHEMA.options, ...NON_HAZARDOUS_WASTE_PRODUCT_TYPES_SCHEMA.options])
        .safeParse(productType).success;
}
